import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainNoticeItem.module.scss'

import IconNew from '@Ui/images/myhouse/IconNew.svg'
import { THUMBNAIL } from '@Root/contants'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  title: string
  isRecent: boolean
  isVisited: boolean
  category: string
  date: string
  view: number
  href: string
  isAttention?: boolean
  imageUrl?: string
}

const MyhouseMainNoticeItem: React.FC<Props> = ({ title, isRecent, isVisited, category, date, view, href, isAttention, imageUrl }: Props) => {
  return (
    <li className={cx('item')}>
      <a href={href} className={cx('link', isVisited && 'type_visited')} onClick={handleNclickMix(NCLICK.MY_HOUSE.MAIN_NOTICE.DETAIL)}>
        <div className={cx('info')}>
          <span className={cx('type')}>{category}</span>
          <strong className={cx('title')}>
            {isAttention && <em className={cx('label')}>필독</em>}
            {isRecent && (
              <>
                <IconNew />
                <span className="blind">new</span>
              </>
            )}
            {title}
          </strong>
          <div className={cx('detail')}>
            <span className={cx('text')}>{date}</span>
            <span className={cx('text')}>조회 {view}</span>
          </div>
        </div>
        {imageUrl && (
          <div className={cx('wrap_image')}>
            <img src={`${imageUrl}?${THUMBNAIL.F176_176}`} alt="" className={cx('image')} />
          </div>
        )}
      </a>
    </li>
  )
}

export default MyhouseMainNoticeItem
